<div [formGroup]="parentForm" class="container" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxLayoutGap.xs="0" *ngIf="patient">
      <div class="item item-1 patient-fields" fxFlex="67%">

            <div class="patient-fields-block">
              <div class="field-row name-dob-row">
                  <div class="item flex-name">
                    <mat-form-field [hideRequiredMarker]="false">
                    	 <mat-label style="font-weight:bold;">FIRST NAME</mat-label>
                      <input matInput placeholder="FIRST NAME" type="text" formControlName="firstName" [ngClass]="{'has-error':parentForm.get('firstName').invalid}" class="bigfont" autocomplete="off" required>

                      <mat-error *ngIf="parentForm.get('firstName').invalid">FIRST NAME IS REQUIRED</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="item flex-name">
                    <mat-form-field [hideRequiredMarker]="false">
                    	 <mat-label style="font-weight:bold;">LAST NAME</mat-label>
                      <input matInput placeholder="LAST NAME" type="text" formControlName="lastName" [ngClass]="{'has-error':parentForm.get('lastName').invalid}" class="bigfont" autocomplete="off" required>
                      <mat-error *ngIf="parentForm.get('lastName').invalid">LAST NAME IS REQUIRED</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="item flex-prefix">
                    <mat-form-field>
                      <mat-label>PREFIX</mat-label>
                      <mat-select formControlName="prefix">
                        <mat-option value="">-</mat-option>
                        <mat-option value="MR">MR</mat-option>
                        <mat-option value="MRS">MRS</mat-option>
                        <mat-option value="MS">MS</mat-option>
                        <mat-option value="MX">MX</mat-option>
                        <mat-option value="MISS">MISS</mat-option>
                        <mat-option value="MSTR">MSTR</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="item flex-dob">
                    <mat-form-field class="date">
                      <mat-label>MMDDYYYY</mat-label>
                      <input matInput [matDatepicker]="dob" (blur)="blurDate()" formControlName="dob" autocomplete="off">
                      <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                      <mat-datepicker #dob></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row">
                  <div class="item flex-grow">
                    <mat-form-field>
                      <input matInput placeholder="ADDRESS" type="text" formControlName="address" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row">
                  <div class="item flex-city">
                    <mat-form-field>
                      <input matInput placeholder="CITY" type="text" formControlName="city" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-state">
                    <mat-form-field>
                      <input matInput placeholder="STATE" aria-label="STATE" [matAutocomplete]="auto" (change)="updateState($event)" [formControl]="stateCtrl" formControlName="state" autocomplete="off">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let state of filteredStates | async" [value]="state.abbreviation">
                          <span>{{ state.abbreviation }} - {{ state.name }}</span>
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                  <div class="item flex-zip">
                    <mat-form-field>
                      <input matInput placeholder="ZIP" type="text" formControlName="zip" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row single-line-row">
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <input matInput class="bigfont" placeholder="HOME PHONE" type="tel" formControlName="phone" autocomplete="off" mask="(000)000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <input matInput class="bigfont" placeholder="WORK PHONE" type="tel" formControlName="phone2"  mask="(000) 000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <input matInput class="bigfont" placeholder="CELL PHONE" type="tel" formControlName="cell"  mask="(000) 000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <input matInput placeholder="EMAIL" type="email" formControlName="email" autocomplete="off">
                    </mat-form-field>
                    <div class="alert alert-danger" *ngIf="0">A valid email is required.</div>
                  </div>
                </div>
            </div>

            <div class="patient-fields-block">
              <div class="field-split field-split-match">
                <div class="field-stack">
                  <div class="item">
                    <mat-form-field>
                      <input matInput placeholder="OCCUPATION" type="text" formControlName="occupation" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item">
                    <mat-form-field>
                      <input matInput placeholder="INTERESTS" type="text" formControlName="interests" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>
                <div class="item field-match-side">
                  <mat-form-field class="textarea-match">
                    <textarea matInput placeholder="FAMILY MEMBERS" formControlName="familyMembers" rows="3" autocomplete="off"></textarea>
                  </mat-form-field>
                </div>
              </div>

              <div class="field-split">
                <div class="field-stack">
                  <div class="item">
                    <app-form-favorites [favorites]="this.patient.favoriteLines" [parentForm]="parentForm"></app-form-favorites>
                  </div>
                  <div class="item">
                    <mat-form-field>
                      <mat-select placeholder="HOW DID YOU FIND US?" formControlName="howDidYouFindUs" autocomplete="off">
                        <mat-option *ngFor="let howDidYouFindUsType of howDidYouFindUsTypes" [(value)]="howDidYouFindUsType.value">
                        {{ howDidYouFindUsType.viewValue }}
                      </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="field-stack">
                  <div class="item">
                    <mat-form-field>
                      <textarea matInput placeholder="BE BACK LIST" formControlName="beBackList" rows="5" autocomplete="off"></textarea>
                    </mat-form-field>
                  </div>
                  <div class="item" *ngIf="parentForm.get('howDidYouFindUs').value=='OTHER'">
                      <mat-form-field>
                      <input matInput placeholder="OTHER" type="text" [(value)]="parentForm.value.howDidYouFindUsOther" formControlName="howDidYouFindUsOther" autocomplete="off">
                      </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

      </div>
      <div class="item item-2" fxFlex="33%">
        <mat-card appearance="outlined" class="patient-notes-card">
          <mat-toolbar>
            <span>PATIENT NOTES</span>
          </mat-toolbar>
          <mat-card-content>
            <div class="patient-notes-fields">
              <div class="item">
                <ckeditor [editor]="ClassicEditorBuild" class="patient-notes-editor" placeholder="PATIENT NOTES" [formControl]="parentForm.controls['patientNotes']" [config]="{toolbar: [ 'Bold', 'Italic' ]}" matInput></ckeditor>
              </div>
              <div class="item">
                <mat-form-field>
                  <mat-label>LAST EXAM</mat-label>
                  <input matInput [matDatepicker]="pickerLastExam" formControlName="lastExam">
                  <mat-datepicker-toggle matSuffix [for]="pickerLastExam"></mat-datepicker-toggle>
                  <mat-datepicker #pickerLastExam></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="item">
                <mat-form-field>
                  <input matInput placeholder="STORE CREDIT" type="text"  formControlName="storeCredit" (blur)="formatCurrency($event,parentForm.controls.storeCredit)" autocomplete="off">
                  <span matPrefix>$&nbsp;</span>
                </mat-form-field>
              </div>
              <div class="item">
                <mat-form-field>
                  <mat-select placeholder="DISCOUNT STATUS" formControlName="discountStatus">
                    <mat-option value="">-</mat-option>
                    <mat-option value="SENIOR">SENIOR</mat-option>
                    <mat-option value="FRIENDSFAMILY">FRIENDS &amp; FAMILY</mat-option>
                    <mat-option value="EMPLOYEE">EMPLOYEE</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="item">
               <mat-checkbox formControlName="sleep">SLEEP</mat-checkbox>
              </div>
              <div class="item">
               <mat-checkbox formControlName="optOut">MARKETING OPT-OUT</mat-checkbox>
              </div>
              <div class="item">
                <mat-form-field>
                  <mat-select placeholder="NOTIFY BY" formControlName="notifyChannel">
                    <mat-option value="EMAIL">EMAIL</mat-option>
                    <mat-option value="TEXT">TEXT</mat-option>
                    <mat-option value="BOTH">EMAIL AND TEXT</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="item">
               <mat-checkbox
                 [checked]="parentForm.get('alertNotes').value || parentForm.get('dns').value"
                 (change)="parentForm.get('alertNotes').setValue($event.checked)"
               >SHOW ALERT</mat-checkbox>
              </div>
              <div class="item">
               <mat-checkbox formControlName="dns" (change)="onDnsChange($event.checked)">DNS</mat-checkbox>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
